import * as z from "zod";

const stripSeparators = (value) => (value ?? "").replace(/[^A-Za-z0-9]/g, "").toUpperCase();

export const tvCodeSchema = z.object({
	code: z
		.string()
		.transform(stripSeparators)
		.pipe(
			z
				.string()
				.length(6, { message: "tvLogin.errors.codeLength" })
				.regex(/^[A-Z0-9]{6}$/, { message: "tvLogin.errors.codeInvalid" })
		),
});

export const tvLoginSchema = z.object({
	email: z.string().email({ message: "tvLogin.errors.emailInvalid" }),
	password: z.string().min(5, { message: "tvLogin.errors.passwordMinLength" }),
	code: z
		.string()
		.transform(stripSeparators)
		.pipe(
			z
				.string()
				.length(6, { message: "tvLogin.errors.codeLength" })
				.regex(/^[A-Z0-9]{6}$/, { message: "tvLogin.errors.codeInvalid" })
		),
});
